import { Form } from "react-bootstrap";
import TextareaAutosize from "react-textarea-autosize";
import {
  SelectAddNew,
  SelectLocaleID,
  SelectSurveyID,
  setEditMode,
  clearTranslationForm,
} from "../../../../features/translations/translationsSlice";
import { useDispatch, useSelector } from "react-redux";
import useFireModal from "../../../../hooks/useFireModal";
import { useState, useEffect } from "react";
import {
  useSaveUpdatedMutation,
  useSaveNewMutation,
} from "../../../../features/translations/translationsApiSlices";

import {
  SelectCurrentFormPage,
  SelectTranslationForm,
  updateTranslationForm,
} from "../../../../features/translations/translationsSlice";

const RenderItems = () => {
  const [fireModal] = useFireModal();

  const addNew = useSelector(SelectAddNew);
  const localeID = useSelector(SelectLocaleID);
  const surveyID = useSelector(SelectSurveyID);
  const currentFormPage = useSelector(SelectCurrentFormPage);
  const formData = useSelector(SelectTranslationForm);
  const dispatch = useDispatch();

  const [saveUpdates] = useSaveUpdatedMutation();
  const [saveNew] = useSaveNewMutation();

  // locale state of the form in order to prevent rerender cascade formdata --> pagination --> formrender
  const [localFormData, setLocalFormData] = useState(formData);

  useEffect(() => {
    setLocalFormData(formData);
  }, [formData]);

  const handleChange = (event) => {
    const id = event.target.getAttribute("id");
    const value = event.target.value;

    const updatedFormData = localFormData.map((item) =>
      item.formFieldId === id ? { ...item, value } : item
    );

    setLocalFormData(updatedFormData);
  };

  // function to update the form data on blur
  const handleBlur = () => {
    dispatch(updateTranslationForm(localFormData));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (addNew === false) {
      const data = formData.map(({ formFieldId, ...keepAttrs }) => keepAttrs);
      await saveUpdates({
        data,
        surveyID,
        localeID,
      })
        .unwrap()
        .then((payload) => {
          fireModal(payload);
          dispatch(setEditMode(false));
          dispatch(clearTranslationForm());
        })
        .catch((error) => {
          fireModal({}, (error = true));
        });
    }

    if (addNew === true) {
      const data = formData.map(({ formFieldId, ...keepAttrs }) => keepAttrs);

      await saveNew({
        data,
        surveyID,
        localeID,
      })
        .unwrap()
        .then((payload) => {
          fireModal(payload);
          dispatch(setEditMode(false));
          dispatch(clearTranslationForm());
        })
        .catch((error) => {
          fireModal({}, (error = true));
        });
    }
  };

  return (
    <>
      <Form id="myform" onSubmit={handleSubmit}>
        {currentFormPage &&
          currentFormPage.map((item) => (
            <div className="row py-2 px-4" key={item.formFieldId}>
              <div className="col-1 ">
                <label>Item ID</label>
                <div className="input-group clockpicker">
                  <input
                    type="text"
                    className="form-control"
                    value={item.id}
                    disabled
                  />
                </div>
              </div>
              <div className="col-2">
                <label>Category</label>
                <input
                  disabled
                  type="text"
                  className="form-control"
                  value={item.category}
                />
              </div>
              <div className="col-4">
                <label>Reference Text</label>
                <TextareaAutosize
                  disabled
                  type="text"
                  className="form-control"
                  id="val-username"
                  value={item.default_value}
                />
              </div>
              <div className="col-4">
                <label>Translation Text</label>
                <TextareaAutosize
                  type="text"
                  className="form-control"
                  id={item.formFieldId}
                  value={
                    localFormData.find(
                      (f) => f.formFieldId === item.formFieldId
                    )?.value || ""
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
            </div>
          ))}
      </Form>
    </>
  );
};

export default RenderItems;
